import { createReducer } from "../../../_common/common.ts";
import { SET_DOCUMENTOS_ACE } from "../actions/constants";

const initialState = {
    documentAce: null,
};

export const documentos_ace = createReducer(initialState, {
    [SET_DOCUMENTOS_ACE]: (state, payload) => {
        state.documentAce = payload.data;
        return state;
    },
});
